import {
    Component,
    forwardRef,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { NG_VALUE_ACCESSOR, FormsModule } from "@angular/forms";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";
import { TextareaTexts } from "./textarea.texts";
import { RequiredDirective } from "../../directives/required/required.directive";
import { InfoComponent } from "../info/info.component";
import { NgClass } from "@angular/common";
import { ValidationMessageComponent } from "../../validation/validation-message/validation-message.component";
import { StringFormatPipe } from "../../pipes/string-format.pipe";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaComponent)
        }
    ],
    selector: "rask-textarea",
    styleUrls: ["./textarea.component.scss"],
    templateUrl: "./textarea.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RequiredDirective,
        InfoComponent,
        FormsModule,
        NgClass,
        ValidationMessageComponent,
        StringFormatPipe
    ]
})
export class TextareaComponent extends ControlValueAccessorBaseComponent implements OnInit {

    @Input() readonly?: any;
    @Input() maxlength?: number;
    @Input() placeholder = "";
    @Input() rows?: number;

    get charsLeft(): string | null {
        if (this.maxlength && this.maxlength > 0 && this.value) {
            return (this.maxlength - this.value.length).toString();
        } else if (this.maxlength) {
            return this.maxlength.toString();
        }
        return null;
    }

    texts = TextareaTexts.texts;

    ngOnInit() {
        this.readonly = this.emptyIsTrue(this.readonly);
        super.ngOnInit();
    }
}
